<template>
  <div class="TableExpandWithTotals">
    <v-card-text v-if="searchActive && dataVals !== null">
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-text>

    <v-data-table
      dense
      :headers="headers"
      :items="dataVals"
      :search="search"
      :custom-filter="customFilter"
      no-results-text="No se encontro el término buscado"
      no-data-text="No hay datos disponibles"
      multi-sort
      disable-initial-sort
      :expand="false"
      class="elevation-1"
      loading="Cargando... Por favor espere."
      rows-per-page-text="Filas por página:"
    >
      <template v-slot:items="props">
        <tr @click.stop="variable = props.item.subt">
        <!-- <tr @click="props.expanded = !props.expanded"> -->
          <td
            v-for="col in columns"
            :key="col.id"
            :align="align(props.item[col])"
          >
            {{ props.item[col] }}
          </td>
        </tr>
      </template>

      <template v-slot:expand="props">
        <v-card flat>
          <v-card-text>Peek-a-boo!</v-card-text>
          <v-btn
            color="primary"
            @click.stop="variable = props.item.institucion"
          >
            Municipios
          </v-btn>
        </v-card>
      </template>

      <template v-if="dataVals.length !== 0" v-slot:footer>
        <td
          v-for="total in totals"
          :key="total.id"
          :align="align(total)"
        >
          <b>{{ total }}</b>
        </td>
      </template>
    </v-data-table>

    <v-card-text>
      <data-table
        :headers="headers"
        :dataVals="variable"
        :searchActive="true"
        :key="tableKey"
      />
    </v-card-text>
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableWithTotals'
export default {
  name: 'TableExpandWithTotals',

  components: {
    'data-table': dataTable
  },

  /**
   * Elementos que recibe el componente para renderizar
   */
  props: {
    /** Cabecera de la tabla */
    headers: {
      type: Array,
      required: true
    },
    /** Contenido de la tabla */
    dataVals: {
      type: Array,
      required: true
    },
    /** Habilita o desahbilita la busqueda */
    searchActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function () {
    return {
      search: '',
      rowsPerPageItems: [5, 10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],

      variable: null
    }
  },

  computed: {
    /**
     * Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []
      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })
      return colVals
    },

    /**
     * Devuelve los valores de las sumatorias de las diferentes columnas,
     * en caso de encontrar un NaN lo evalua como 0
     * Si la columna tiene un valor str, usa este valor como total
     * Si la columna tiene un valor enu, devuelve el total de filas
     * @return {Array} sumatorias de las columnas
     */
    'totals': function totals () {
      var sums = []

      for (var i = 0; i < this.columns.length; i++) {
        if (this.headers[i].str) {
          sums.push(this.headers[i].str)
        } else if (this.headers[i].enu) {
          sums.push(this.dataVals.length)
        } else {
          let cmp = this.columns[i]
          sums.push(this.dataVals.reduce(function (accumulator, val) {
            return accumulator + (val[cmp] ? val[cmp] : 0)
          }, 0))
        }
      }

      return sums
    }
  },

  methods: {
    /**
     * Determina la alineación de la celda, si es string se alinea a la izquierda
     * para los demas casos se alinea a la derecha
     * @param  {string} val El valor a evaluar
     * @return {string}     La alineación a usar
     */
    align (val) {
      let algn = 'right'
      if (typeof val === 'string' && val[val.length - 1] !== '%') {
        algn = 'left'
      }
      return algn
    }
  }
}
</script>
